import React, { FunctionComponent, ReactNode } from 'react'

import styles from './style.module.scss'

export interface ContainerProps {
  testNameSpace?: string
  children: ReactNode
}

export const Container: FunctionComponent<ContainerProps> = ({ children, testNameSpace = '', ...otherProps }) => (
  <div className={styles.container} {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-container` })} {...otherProps}>
    {children}
  </div>
)
